<template>
  <div class="w-100">
    <grid-component
        isResizable
        isReorderable
        :canEdit="checkClaim(CAN_EDIT_WORK_ORDER)"
        :canDelete="checkClaim(CAN_DELETE_WORK_ORDERS)"
        :gridId="gridId"
        :itemData="itemData"
        :fields="fields"
        :onEdit="onEdit"
        :onDelete="onDelete"
        :handleRowClick="onRowClick"
        @checkedItem="checkedRowItemIds=$event"
      />
    <edit-line v-if="fromEditPage && lastOpenedId && (checkClaim(CAN_EDIT_WORK_ORDER) || checkClaim(CAN_ADD_WORK_ORDER))"
               :serviceOrderId="serviceOrderId" @onHiddenLineItem="onAfterSave"></edit-line>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import { GRID_ID } from '@/shared/constants';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';
import EditLine from '../ServiceOrderLineItems/index'

export default {
  components: {
    GridComponent,
    EditLine
  },
  props: {
    serviceOrderId: {
      type:  [Number, String],
      default: 0,
    },
    fromEditPage: {
      type:  Boolean,
      default: false,
    },
},
  data: () => ({
    selectedRowItemId: 0,
    gridId: GRID_ID.SERVICE_ORDER_LINES,
    fields: gridFields,
    checkedRowItemIds: [],
  }),
  computed: {
    ...mapGetters('serviceOrderLines', ['lastOpenedId']),
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('serviceOrderLines', ['serviceOrderLines']),
    /*serviceOrderLines() {
      return this.serviceOrderLinesById(this.serviceOrderId);
    },*/
    itemData() {
      if (this.serviceOrderLines == undefined || !this.serviceOrderLines.length) return [];
      return this.serviceOrderLines.map((serviceOrderLine) => ({ ...serviceOrderLine, selected: serviceOrderLine.id === this.selectedRowItemId }));
    },
  },
  methods: {
    ...mapActions('serviceOrderLines', [
      'getByServiceOrderId',
      'deleteServiceOrderLine'
    ]),
    /*...mapMutations('serviceOrderLines', ['setLastOpenedId','clearServiceOrderLines']),*/
    ...mapMutations('serviceOrderLines', { setserviceOrderLineItem: 'setItem'} ),
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
      /*this.setLastOpenedId(row.dataItem.id)*/
      this.setserviceOrderLineItem({ resource: 'lastOpenedId', payload: row.dataItem.id })
      // this.$bvModal.show("edit-service-order-line")
    },
    onAfterSave() {
      this.$emit('onAfterSave');
    },
    onEdit(row) {
      //console.log(row);
      this.selectedRowItemId = row.id;
      /*this.setLastOpenedId(row.id)*/
      this.setserviceOrderLineItem({ resource: 'lastOpenedId', payload: row.id })
      this.$bvModal.show("edit-service-order-line")
    },
    async onDelete({id,serviceOrderId}) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete work order line with id :${id}?`});
      if (deleteConfirmed) {
        const result = await this.deleteServiceOrderLine({id,serviceOrderId});
        this.onAfterSave();
      }
    },
  },
  watch: {
    serviceOrderId() {
      if(this.serviceOrderId) {
        this.getByServiceOrderId(this.serviceOrderId);
      } else {
        /*this.clearServiceOrderLines();*/
        this.setserviceOrderLineItem({ resource: 'serviceOrderLines', payload: [] })
      }
    },
    serviceOrderLines() {
      if(this.serviceOrderLines.length > 0 && this.selectedRowItemId === 0){
        this.selectedRowItemId = this.serviceOrderLines[0].id;
        /*this.setLastOpenedId(this.selectedRowItemId)*/
        this.setserviceOrderLineItem({ resource: 'lastOpenedId', payload: this.selectedRowItemId })
      }
    },
    selectedRowItemId(newVal) {
      const selectedRow = this.serviceOrderLines.find(serviceOrderLine => serviceOrderLine.id === newVal);
      this.$emit('selectedServiceOrderLine', selectedRow);
    },
    checkedRowItemIds() {
      this.$emit('updateCheckedRowItemIds', this.checkedRowItemIds);
    },
  },
  mounted() {
    /*if(this.lastOpenedId) {
      this.selectedRowItemId = this.lastOpenedId;
    }*/
    if(this.serviceOrderId){
      this.getByServiceOrderId(this.serviceOrderId);
    }
  },
};
</script>

<style scoped>
.service-order-lines-grid {
  height: 185px !important;
}
</style>
